import { Route, Routes } from 'react-router-dom';
import './App.css';
import NavBar from './Components/navbar/NavBar';
import Error from './Components/pages/error/Error';
import Home from './Components/pages/home/Home';
import AboutUs from './Components/pages/aboutus/AboutUs';
import Contact from './Components/pages/contact/Contact';
import Footer from './Components/footer/Footer';


function App() {
  return (
    <div className="App">
      <NavBar />
      <Routes>
      <Route path='/' element={<Home />} />
      <Route path='*' element={<Error />} />
      <Route path='/about' element={<AboutUs />} />
      <Route path='/contact' element={<Contact />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
